<template>
  <v-container id="calculator-wrapper">
    <div class="hero-image hero-image5">
      <div class="hero-text">
        <h1 class="mb-4 heading">
            Calculate Monthly Earnings
          </h1>
          <h4 class="subheading">
            earning | MCD
          </h4>
          <h4 class="subheading" >
            Practice Owners MCD Profit Sharing
          </h4>
      </div>
    </div>
    <v-container class="calculator-container">
      <v-row>
        <v-col class="input-column">
          <v-container>
            <v-row>
              <v-col class="section-header text-center header-text">INPUTS</v-col>
            </v-row>
            <v-row>
              <v-col class="section-header header-text">Current Monthly Office Performance</v-col>
            </v-row>
            <v-row class="column-labels">
              <v-col></v-col>
              <v-col md="2" class="col-input col-header">Scenario 1</v-col>
              <v-col md="2" class="col-input col-header">Scenario 2</v-col>
            </v-row>
          </v-container>
          <v-row align="center" justify="center" class="calculator-row "> <!--Doctor FTE -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Doctor FTE</span>
                </template>
                <span v-html="this.tipDoctorFTE"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="txtDoctorFTECurrent"
                  filled rounded reverse
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="txtDoctorFTECalculated"
                  filled rounded reverse
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row"><!--Doctor Days Worked-->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Doctor Days Worked</span>
                </template>
                <span  v-html="this.tipDoctorDaysWorked"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar"></div>
              <v-text-field
                  v-model="txtDoctorDaysWorkedCurrent"
                  placeholder=""
                  type="number"
                  @input="updateFields"
                  filled
                  rounded
                  style="height: 30px; border-radius:10px;"
                  reverse
                  class="text-blue number-input"
                  hide-spin-buttons
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar"></div>
              <v-text-field
                  v-model="txtDoctorDaysWorkedCalculated"
                  placeholder=""
                  type="number"
                  @input="updateFields"
                  filled
                  rounded
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row"> <!--Monthly Revenue-->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Monthly Revenue</span>
                </template>
                <span v-html="this.tipMonthlyRevenue"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="txtMonthlyRevenueCurrent"
                  placeholder=""
                  type="text"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="txtMonthlyRevenueCalculated"
                  placeholder=""
                  type="text"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row"> <!-- Monthly Center Expenses-->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Monthly Center Expenses</span>
                </template>
                <span v-html="this.tipMonthlyCenterExpenses"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="txtMonthlyCenterExpensesCurrent"
                  placeholder=""
                  type="text"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="txtMonthlyCenterExpensesCalculated"
                  placeholder=""
                  type="text"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-container>
            <v-row>
              <v-col class="section-header header-text">Additional Associate Assumptions</v-col>
            </v-row>
            <v-row class="column-labels">
              <v-col></v-col>
              <v-col md="2" class="col-input col-header">Scenario 1</v-col>
              <v-col md="2" class="col-input col-header">Scenario 2</v-col>
            </v-row>
          </v-container><v-row align="center" justify="center" class="calculator-row"><!--Days Worked Per Month-->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Days Worked Per Month</span>
                </template>
                <span v-html="this.tipAssociateDaysWorkedPerMonth"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar"></div>
              <v-text-field
                  v-model="txtAssociateDaysWorkedPerMonthCurrent"
                  placeholder=""
                  type="number"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar"></div>
              <v-text-field
                  v-model="txtAssociateDaysWorkedPerMonthCalculated"
                  placeholder=""
                  type="number"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row"><!--Production Per Day-->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Production Per Day</span>
                </template>
                <span v-html="this.tipAssociateProductionPerDay"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="txtAssociateProductionPerDayCurrent"
                  placeholder=""
                  type="text"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="txtAssociateProductionPerDayCalculated"
                  placeholder=""
                  type="text"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row"><!--Daily Guarantee-->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Daily Guarantee</span>
                </template>
                <span v-html="this.tipAssociateDailyGuarantee"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="txtAssociateDailyGuaranteeCurrent"
                  placeholder=""
                  type="text"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="txtAssociateDailyGuaranteeCalculated"
                  placeholder=""
                  type="text"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row"><!-- Patient Net Promoter Score (NPS) -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  >  Patient Satisfaction Score (NPS) </span>
                </template>
                <span v-html="this.tipAssociatePSAT"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar"></div>
              <v-text-field
                  v-model="txtAssociatePSATCurrent"
                  placeholder=""
                  type="number"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar"></div>
              <v-text-field
                  v-model="txtAssociatePSATCalculated"
                  placeholder=""
                  type="number"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row"><!--Minimum Profit Sharing %-->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Minimum Profit Sharing %</span>
                </template>
                <span v-html="this.tipAssociateMinimumProfitShare"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="percent">%</div>
              <v-text-field
                  v-model="txtAssociateMinimumProfitShareCurrent"
                  placeholder=""
                  type="number"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input percent-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="percent">%</div>
              <v-text-field
                  v-model="txtAssociateMinimumProfitShareCalculated"
                  placeholder=""
                  type="number"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input percent-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row"><!--Maximum Profit Sharing %-->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Maximum Profit Sharing %</span>
                </template>
                <span v-html="this.tipAssociateMaximumProfitShare"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="percent">%</div>
              <v-text-field
                  v-model="txtAssociateMaximumProfitShareCurrent"
                  placeholder=""
                  type="number"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input percent-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="percent">%</div>
              <v-text-field
                  v-model="txtAssociateMaximumProfitShareCalculated"
                  placeholder=""
                  type="number"
                  filled
                  rounded
                  @input="updateFields"
                  style="height: 30px; border-radius:10px"
                  reverse
                  class="text-blue number-input percent-input"
                ></v-text-field>
            </v-col>
          </v-row>

        </v-col> <!--END Input column-->
        <v-col  class="blueBackground results-column">
          <v-container>
            <v-row>
              <v-col class="section-header text-center header-text">TITLE NEEDED</v-col>
            </v-row>
            <v-row class="column-labels">
              <v-col></v-col>
              <v-col md="2" class="col-input col-header">Scenario 1</v-col>
              <v-col md="2" class="col-input col-header">Scenario 2</v-col>
            </v-row>
          </v-container>
          <v-container>
            <v-row>
              <v-col class="section-header header-text">Total P&L</v-col>
            </v-row>
          </v-container>
          <v-row align="center" justify="center" class="calculator-row"><!-- Revenue -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Revenue</span>
                </template>
                <span v-html="this.tipRevenue"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultRevenueCurrentFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultRevenueCalculatedFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row"><!-- Center Expenses -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Center Expenses</span>
                </template>
                <span v-html="this.tipCenterExpenses"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultCenterExpensesCurrentFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultCenterExpensesCalculatedFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="blueBackgroundHighlight"><!-- Center Gross Profit -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header-bold"
                    v-bind="attrs"
                    v-on="on"
                  > Center Gross Profit</span>
                </template>
                <span v-html="this.tipCenterGrossProfit"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultCenterGrossProfitCurrentFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultCenterGrossProfitCalculatedFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row"><!-- Monthly Guarantee -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Monthly Guarantee</span>
                </template>
                <span v-html="this.tipMonthlyGuarantee"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultMonthlyGuaranteeCurrentFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultMonthlyGuaranteeCalculatedFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row blueBackgroundHighlight"><!-- PC Gross Profits -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header-bold"
                    v-bind="attrs"
                    v-on="on"
                  > PC Gross Profit</span>
                </template>
                <span v-html="this.tipPCGrossProfit"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultPCGrossProfitCurrentFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultPCGrossProfitCalculatedFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row"> <!-- Actual Profit Share % based on NPS score -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Actual Profit Share % based on NPS score</span>
                </template>
                <span v-html="this.tipAssociateProfitShare"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultMCDProfitShareCurrent"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultMCDProfitShareCalculated"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row"> <!-- Associate Expenses -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  > Associate Expenses</span>
                </template>
                <span v-html="this.tipAssociateExpenses"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultAssociateExpensesCurrentFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultAssociateExpensesCalculatedFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row"> <!-- Shared Associate Expenses-->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header"
                    v-bind="attrs"
                    v-on="on"
                  >Shared Associate Expenses</span>
                </template>
                <span v-html="this.tipSharedAssociateExpenses"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultSharedAssociateExpensesCurrentFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultSharedAssociateExpensesCalculatedFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="calculator-row blueBackgroundHighlight"> <!-- PC Net Proft -->
            <v-col class="calculator-label">
              <v-tooltip bottom max-width="400" class="tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="input-header-bold"
                    v-bind="attrs"
                    v-on="on"
                  >PC Net Proft</span>
                </template>
                <span v-html="this.tipPCNetProfit"></span>
              </v-tooltip>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultPCNetProfitCurrentFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
            <v-col md="2" class="col-input">
              <div class="dollar">$</div>
              <v-text-field
                  v-model="resultPCNetProfitCalculatedFormatted"
                  filled rounded reverse readonly
                  type="text"
                  style="height: 30px; border-radius:10px"
                  class="text-bold number-input"
                ></v-text-field>
            </v-col>
          </v-row>


          <v-row class="instructions-row">
            <v-col class= "instructions-right disclaimer">Center expenses may vary month to month. Example above reflective of supplies equal to 35% of MCD revenue and 25% of Associate Revenue.*</v-col>
          </v-row>
          <v-row class="instructions-row">
            <v-col class= "instructions-right disclaimer disclaimer-footnote">
              <ul><li>*Assumes participation in new BSA</li><li>*Direct Costs may vary month to month</li></ul>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>
<style scoped>
.number-input >>> input[type="number"] {
  -moz-appearance: textfield;
}
.number-input >>> input::-webkit-outer-spin-button,
.number-input >>> input::-webkit-inner-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
</style>
<script>
  export default {
    name: 'Calculator',
    methods: {
      updateFields (){

        this.numMonthlyRevenueCurrent = this.txtMonthlyRevenueCurrent.toString().replaceAll(',', '');
        this.numMonthlyRevenueCalculated = this.txtMonthlyRevenueCalculated.toString().replaceAll(',', '');
        this.numMonthlyCenterExpensesCurrent = this.txtMonthlyCenterExpensesCurrent.toString().replaceAll(',', '');
        this.numMonthlyCenterExpensesCalculated = this.txtMonthlyCenterExpensesCalculated.toString().replaceAll(',', '');
        this.numAssociateProductionPerDayCurrent = this.txtAssociateProductionPerDayCurrent.toString().replaceAll(',', '');
        this.numAssociateProductionPerDayCalculated = this.txtAssociateProductionPerDayCalculated.toString().replaceAll(',', '');
        this.numAssociateDailyGuaranteeCurrent = this.txtAssociateDailyGuaranteeCurrent.toString().replaceAll(',', '');
        this.numAssociateDailyGuaranteeCalculated = this.txtAssociateDailyGuaranteeCalculated.toString().replaceAll(',', '');
        /* Revenue */
        if(Number(this.numMonthlyRevenueCurrent) > 0 )
        { this.resultRevenueCurrent = Number(this.numMonthlyRevenueCurrent) + Number(this.txtAssociateDaysWorkedPerMonthCurrent * this.numAssociateProductionPerDayCurrent);}
        else
        { this.resultRevenueCurrent = 0;}
        if(Number(this.numMonthlyRevenueCalculated) > 0 )
        { this.resultRevenueCalculated = Number(this.numMonthlyRevenueCalculated) + Number(this.txtAssociateDaysWorkedPerMonthCalculated * this.numAssociateProductionPerDayCalculated);}
        else
        { this.resultRevenueCalculated = 0;}
        this.resultRevenueCurrentFormatted = this.roundAndFormat(this.resultRevenueCurrent);
        this.resultRevenueCalculatedFormatted = this.roundAndFormat(this.resultRevenueCalculated);
        /* Center Expenses */
        this.resultCenterExpensesCurrent = Number(this.numMonthlyCenterExpensesCurrent) + Number((this.txtAssociateDaysWorkedPerMonthCurrent * this.numAssociateProductionPerDayCurrent) * .3);
        this.resultCenterExpensesCalculated = Number(this.numMonthlyCenterExpensesCalculated) + Number((this.txtAssociateDaysWorkedPerMonthCalculated * this.numAssociateProductionPerDayCalculated) * .3);
        this.resultCenterExpensesCurrentFormatted = this.roundAndFormat(this.resultCenterExpensesCurrent);
        this.resultCenterExpensesCalculatedFormatted = this.roundAndFormat(this.resultCenterExpensesCalculated);
        /* Associate Profit Share % (Calculated) */
        this.resultAssociateProfitShareCurrent = this.getAssociateProfitSharing(this.txtAssociatePSATCurrent, "CURRENT");
        this.resultAssociateProfitShareCalculated = this.getAssociateProfitSharing(this.txtAssociatePSATCalculated, "CALCULATED");
        this.resultAssociateProfitShareCurrentFormatted = this.roundAndFormat(this.resultAssociateProfitShareCurrent);
        this.resultAssociateProfitShareCalculatedFormatted = this.roundAndFormat(this.resultAssociateProfitShareCalculated);
        /* Associate Expenses */

        this.resultAssociateExpensesCurrent    =  Math.max((this.txtAssociateDaysWorkedPerMonthCurrent * this.numAssociateDailyGuaranteeCurrent * 1.1) ,
                                                        (this.resultAssociateProfitShareCurrent/100 * (this.resultRevenueCurrent - this.resultCenterExpensesCurrent))*1.1);
        this.resultAssociateExpensesCalculated =  Math.max((this.txtAssociateDaysWorkedPerMonthCalculated * this.numAssociateDailyGuaranteeCalculated * 1.1) ,
                                                        (this.resultAssociateProfitShareCalculated/100 * (this.resultRevenueCalculated - this.resultCenterExpensesCalculated))*1.1);
        this.resultAssociateExpensesCurrentFormatted = this.roundAndFormat(this.resultAssociateExpensesCurrent);
        this.resultAssociateExpensesCalculatedFormatted = this.roundAndFormat(this.resultAssociateExpensesCalculated);
        /* Shared Associate Expenses */
        if( (Number(this.txtDoctorDaysWorkedCurrent) + Number(this.txtAssociateDaysWorkedPerMonthCurrent))/22 > 1.5 ){ this.resultSharedAssociateExpensesCurrent = this.resultAssociateExpensesCurrent * .5 * -1;}
        else {this.resultSharedAssociateExpensesCurrent = 0;}
        if( (Number(this.txtDoctorDaysWorkedCalculated) + Number(this.txtAssociateDaysWorkedPerMonthCalculated))/22 > 1.5 ){ this.resultSharedAssociateExpensesCalculated = this.resultAssociateExpensesCalculated * .5 * -1;}
        else {this.resultSharedAssociateExpensesCalculated = 0;}
        this.resultSharedAssociateExpensesCurrentFormatted = this.roundAndFormat(this.resultSharedAssociateExpensesCurrent);
        this.resultSharedAssociateExpensesCalculatedFormatted = this.roundAndFormat(this.resultSharedAssociateExpensesCalculated);
        /* Center Gross Profit */
        this.resultCenterGrossProfitCurrent = this.resultRevenueCurrent - this.resultCenterExpensesCurrent - this.resultSharedAssociateExpensesCurrent;
        this.resultCenterGrossProfitCalculated = this.resultRevenueCalculated - this.resultCenterExpensesCalculated - this.resultSharedAssociateExpensesCalculated;
        this.resultCenterGrossProfitCurrentFormatted = this.roundAndFormat(this.resultCenterGrossProfitCurrent);
        this.resultCenterGrossProfitCalculatedFormatted = this.roundAndFormat(this.resultCenterGrossProfitCalculated);
        /* Monthly Guarantee*/
        this.resultMonthlyGuaranteeCurrent = this.txtAssociateDailyGuaranteeCurrent * this.txtAssociateDaysWorkedPerMonthCurrent;
        this.resultMonthlyGuaranteeCalculated = this.txtAssociateDailyGuaranteeCalculated * this.txtAssociateDaysWorkedPerMonthCalculated;

        this.resultMonthlyGuaranteeCurrentFormatted = this.roundAndFormat(this.resultMonthlyGuaranteeCurrent);
        this.resultMonthlyGuaranteeCalculatedFormatted = this.roundAndFormat(this.resultMonthlyGuaranteeCalculated);
        /* PC Gross Profit */
        if( this.resultDoctorFTECurrent > 1.5 ){  this.resultPCGrossProfitCurrent = this.resultCenterGrossProfitCurrent * .55; }
        else {this.resultPCGrossProfitCurrent = this.resultCenterGrossProfitCurrent * .5;}
        if( this.resultDoctorFTECalculated > 1.5 ){  this.resultPCGrossProfitCalculated = this.resultCenterGrossProfitCalculated * .55; }
        else {this.resultPCGrossProfitCalculated = this.resultCenterGrossProfitCalculated * .5;}
        this.resultPCGrossProfitCurrentFormatted = this.roundAndFormat(this.resultPCGrossProfitCurrent);
        this.resultPCGrossProfitCalculatedFormatted = this.roundAndFormat(this.resultPCGrossProfitCalculated);
        /*MCD Profit Share % (Calculated)*/
        this.resultMCDProfitShareCurrent = this.getAssociateProfitSharing(this.txtAssociatePSATCurrent, "CURRENT");
        this.resultMCDProfitShareCalculated = this.getAssociateProfitSharing(this.txtAssociatePSATCalculated, "CALCULATED");
        this.resultMCDProfitShareCurrentFormatted = this.roundAndFormat(this.resultMCDProfitShareCurrent);
        this.resultMCDProfitShareCalculatedFormatted = this.roundAndFormat(this.resultMCDProfitShareCalculated);
        /* MCD Expenses */
        var mcdExpensesCalculationCurrent;
        if(this.txtMCDDaysWorkedPerMonthCurrent >= 15 ) {
          mcdExpensesCalculationCurrent = this.resultMCDProfitShareCurrent/100 * ( this.resultRevenueCurrent - (this.resultCenterExpensesCurrent * .5) - ( this.resultAssociateExpensesCurrent + this.resultSharedAssociateExpensesCurrent)) * 1.1 }
        else {
          mcdExpensesCalculationCurrent = 1.1 * (this.resultMCDProfitShareCurrent/100 * ( this.resultRevenueCurrent - (this.resultCenterExpensesCurrent * .5) - ( this.resultAssociateExpensesCurrent + this.resultSharedAssociateExpensesCurrent)) * this.txtMCDDaysWorkedPerMonthCurrent/22);}
        this.resultMCDExpensesCurrent = Math.max(( this.txtMCDDaysWorkedPerMonthCurrent * this.numMCDDailyGuaranteeCurrent * 1.1), mcdExpensesCalculationCurrent);
        var mcdExpensesCalculationCalculated;
        if(this.txtMCDDaysWorkedPerMonthCalculated >= 15 ) {
          mcdExpensesCalculationCalculated = this.resultMCDProfitShareCalculated/100 * ( this.resultRevenueCalculated - (this.resultCenterExpensesCalculated * .5) - ( this.resultAssociateExpensesCalculated + this.resultSharedAssociateExpensesCalculated)) * 1.1 }
        else {
          mcdExpensesCalculationCalculated = 1.1 * (this.resultMCDProfitShareCalculated/100 * ( this.resultRevenueCalculated - (this.resultCenterExpensesCalculated * .5) - ( this.resultAssociateExpensesCalculated + this.resultSharedAssociateExpensesCalculated)) * this.txtMCDDaysWorkedPerMonthCalculated/22);}
        this.resultMCDExpensesCalculated = Math.max(( this.txtMCDDaysWorkedPerMonthCalculated * this.numMCDDailyGuaranteeCalculated * 1.1), mcdExpensesCalculationCalculated);
        this.resultMCDExpensesCurrentFormatted = this.roundAndFormat(this.resultMCDExpensesCurrent);
        this.resultMCDExpensesCalculatedFormatted = this.roundAndFormat(this.resultMCDExpensesCalculated);
        /* PC Net Profit */
        this.resultPCNetProfitCurrent = this.resultPCGrossProfitCurrent - this.resultAssociateExpensesCurrent - this.resultSharedAssociateExpensesCurrent;
        this.resultPCNetProfitCalculated = this.resultPCGrossProfitCalculated - this.resultAssociateExpensesCalculated - this.resultSharedAssociateExpensesCalculated;
        this.resultPCNetProfitCurrentFormatted = this.roundAndFormat(this.resultPCNetProfitCurrent);
        this.resultPCNetProfitCalculatedFormatted = this.roundAndFormat(this.resultPCNetProfitCalculated);
      },
      getAssociateProfitSharing(psat, currentOrCalculated) {
          var delta;
          var profitShare;
          var minimum;
          if(currentOrCalculated == "CURRENT"){
              minimum = Number(this.txtAssociateMinimumProfitShareCurrent);
              delta = (Number(this.txtAssociateMaximumProfitShareCurrent) - Number(this.txtAssociateMinimumProfitShareCurrent))/4;
            }
          else if(currentOrCalculated == "CALCULATED"){
              minimum = Number(this.txtAssociateMinimumProfitShareCalculated);
              delta = (Number(this.txtAssociateMaximumProfitShareCalculated) - Number(this.txtAssociateMinimumProfitShareCalculated))/4;
            }
          if (psat < 4.19) {
            profitShare = Number(minimum);
          }
          else if(psat < 4.39) {
            profitShare = Number(minimum) + delta;
          }
          else if(psat < 4.59) {
            profitShare = Number(minimum) + delta*2;
          }
          else if(psat < 4.79) {
            profitShare = Number(minimum) + delta*3;
          }
          else {
            profitShare = Number(minimum) + delta*4;
          }
          return profitShare;
      },
      roundAndFormat(number) {
        var result = Math.round(number);
        result = result.toLocaleString();
        return result;
      },
      currencyFormat(number){
        var currency = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(number);
        return currency;
      },
      reset(){
        this.updateFields();
      },
    },

    data: () => ({
      txtDoctorFTECurrent: 1.0,
      txtDoctorFTECalculated: 1.0,
      txtDoctorDaysWorkedCurrent: 22,
      txtDoctorDaysWorkedCalculated: 22,
      txtMonthlyRevenueCurrent: "150,000",
      txtMonthlyRevenueCalculated: "150,000",
      txtMonthlyCenterExpensesCurrent: "37,500",
      txtMonthlyCenterExpensesCalculated: "37,500",
      /*Additional Associate Assumptions*/
      txtAssociateDaysWorkedPerMonthCurrent: 18,
      txtAssociateDaysWorkedPerMonthCalculated: 18,
      txtAssociateProductionPerDayCurrent: "4,000",
      txtAssociateProductionPerDayCalculated: "4,000",
      txtAssociateDailyGuaranteeCurrent: "800",
      txtAssociateDailyGuaranteeCalculated: "800",
      txtAssociatePSATCurrent: 4.95,
      txtAssociatePSATCalculated: 4.95,
      txtAssociateMinimumProfitShareCurrent: 8,
      txtAssociateMinimumProfitShareCalculated: 8,
      txtAssociateMaximumProfitShareCurrent:10,
      txtAssociateMaximumProfitShareCalculated:10,

      /*Results*/
      resultRevenueCurrent: null,
      resultRevenueCalculated: null,
      resultCenterExpensesCurrent: null,
      resultCenterExpensesCalculated: null,
      resultCenterGrossProfitCurrent: null,
      resultCenterGrossProfitCalculated: null,
      resultPCGrossProfitCurrent: null,
      resultPCGrossProfitCalculated: null,
      resultAssociateProfitShareCurrent: null,
      resultAssociateProfitShareCalculated: null,
      resultAssociateExpensesCurrent: null,
      resultAssociateExpensesCalculated: null,
      resultSharedAssociateExpensesCurrent: null,
      resultSharedAssociateExpensesCalculated: null,
      resultMCDProfitShareCurrent: null,
      resultMCDProfitShareCalculated: null,
      resultMCDExpensesCurrent: null,
      resultMCDExpensesCalculated: null,
      resultPCNetProfitCurrent: null,
      resultPCNetProfitCalculated: null,


      /*Formateted for display*/

      /*Tooltip hover values*/
      //"<p><strong></strong></p>"
      tipDoctorDaysWorked: "<p><strong>Doctor Days Worked</strong></p> Number of days worked per month.",
      tipMonthlyRevenue: "<p><strong>Monthly Revenue</strong></p> Monthly revenue at location.",
      tipMonthlyCenterExpenses: "<p><strong>Monthly Center Expenses</strong></p>",
      tipMCDDaysWorkedPerMonth: "<p><strong>MCD Days Worked Per Month</strong></p>",
      tipMCDProductionPerDay: "<p><strong>MCD Production Per Day</strong></p>",
      tipMCDDailyGuarantee: "<p><strong>Daily Guarantee</strong></p>",
      tipMCDPSAT: "<p><strong> Patient Net Promoter Score (NPS) </strong>Patient Satisfaction measured by Patient NPS (90 Day) – see Patient Experience Survey Dashboard.</p>",
      tipMCDMinimumProfitShare: "<p><strong>Minimum Profit Share %</strong></p>",
      tipMCDMaximumProfitShare: "<p><strong>Maximum Profit Share %</strong></p>",
      tipAssociateDaysWorkedPerMonth: "<p><strong>Associate Days Worked Per Month</strong></p>",
      tipAssociateProductionPerDay: "<p><strong>Associate Production Per Day</strong></p>",
      tipAssociateDailyGuarantee: "<p><strong>Associate Daily Guarantee</strong></p>",
      tipAssociatePSAT: "<p><strong>Associate Patient Satisfaction Score (NPS) </strong>Patient Satisfaction measured by Patient NPS (90 Day) – see Patient Experience Survey Dashboard.</p>",
      tipAssociateMinimumProfitShare: "<p><strong>Associate Minimum Profit Share %</strong></p>",
      tipAssociateMaximumProfitShare: "<p><strong>Associate Maximum Profit Share %</strong></p>",
      tipDoctorFTE: "<p><strong>Doctor FTE</strong></p>Assumes Days Open is 22 Days.",
      tipRevenue: "<p><strong>Revenue</strong></p>Total revenue at location.",
      tipCenterExpenses: "<p><strong>Center Expenses</strong></p>Center expenses at location. (Supplies, Office Staffing Costs, & Other Center Expenses).",
      tipCenterGrossProfit: "<p><strong>Center Gross Profit</strong></p>Calculation = Revenue - Center Expenses.",
      tipMonthlyGuarantee: "<p><strong>Center Gross Profit</strong></p>Calculation = Revenue - Center Expenses",
      tipPCGrossProfit: "<p><strong>PC Gross Profit</strong></p>Calculation = Center gross profit x BSA fee (BSA Fee = 55% under 1.5 FTEs; 50% at or above 1.5 FTEs).",
      tipAssociateProfitShare: "<p><strong>Associate Profit Share % (Calculated)</strong></p>Scaled based on NPS Score.",
      tipAssociateExpenses: "<p><strong>Associate Expenses</strong></p>Includes all associate expenses, offset by credit below.",
      tipSharedAssociateExpenses: "<p><strong>Shared Associate Expenses</strong></p>Associate expenses are shared when Dr. FTEs exceed 1.5.",
      tipMCDProfitShare: "<p><strong>MCD Profit Share % (Calculated)</strong></p>",
      tipMCDExpenses: "<p><strong>MCD Expenses</strong></p>Max of daily rate or profit share amount + 10% for malpractice, etc.",
      tipPCNetProfit: "<p><strong>PC Net Profit</strong></p>Calculation = PC Gross Profit, less profit share and ancillary costs.",

    }),
    watch: {
      txtMonthlyRevenueCurrent: function(newValue) {
        const result = newValue.replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.$nextTick(() => this.txtMonthlyRevenueCurrent = result);
      },
      txtMonthlyRevenueCalculated: function(newValue) {
        const result = newValue.replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.$nextTick(() => this.txtMonthlyRevenueCalculated = result);
      },
      txtMonthlyCenterExpensesCurrent: function(newValue) {
        const result = newValue.replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.$nextTick(() => this.txtMonthlyCenterExpensesCurrent = result);
      },
      txtMonthlyCenterExpensesCalculated: function(newValue) {
        const result = newValue.replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.$nextTick(() => this.txtMonthlyCenterExpensesCalculated = result);
      },
      txtAssociateProductionPerDayCurrent: function(newValue) {
        const result = newValue.replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.$nextTick(() => this.txtAssociateProductionPerDayCurrent = result);
      },
      txtAssociateProductionPerDayCalculated: function(newValue) {
        const result = newValue.replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.$nextTick(() => this.txtAssociateProductionPerDayCalculated = result);
      },
      txtMCDProductionPerDayCurrent: function(newValue) {
        const result = newValue.replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.$nextTick(() => this.txtMCDProductionPerDayCurrent = result);
      },
      txtMCDProductionPerDayCalculated: function(newValue) {
        const result = newValue.replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.$nextTick(() => this.txtMCDProductionPerDayCalculated = result);
      },
      txtAssociateDailyGuaranteeCurrent: function(newValue) {
        const result = newValue.replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.$nextTick(() => this.txtAssociateDailyGuaranteeCurrent = result);
      },
      txtAssociateDailyGuaranteeCalculated: function(newValue) {
        const result = newValue.replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.$nextTick(() => this.txtAssociateDailyGuaranteeCalculated = result);
      },
      txtMCDDailyGuaranteeCurrent: function(newValue) {
        const result = newValue.replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.$nextTick(() => this.txtMCDDailyGuaranteeCurrent = result);
      },
      txtMCDDailyGuaranteeCalculated: function(newValue) {
        const result = newValue.replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.$nextTick(() => this.txtMCDDailyGuaranteeCalculated = result);
      }
    },
    created(){
      this.updateFields();
    },
  }
</script>